module.exports = __webpack_public_path__ + "static/media/blueFolder.5abe249b.svg";